// NOTE: old version of Node will not support Object.fromEntries
// thus Jest tests may fail and require polyfil, but browsers will support it

import logger from 'utils/logger.util';

const L = logger('fromEntriesToObject');

const fromEntries =
  Object.fromEntries ??
  (() => {
    // NOTE: IIFE is in order to put a name to the function, but have it only created if Object.fromEntries is missing

    // noinspection UnnecessaryLocalVariableJS
    const fromEntriesPolyfill = (entries) => [...entries].reduce((o, [k, v]) => Object.assign(o, { [k]: v }), {});
    return fromEntriesPolyfill;
  })();

const fromEntriesToObject = (entries) => {
  try {
    return fromEntries(entries);
  } catch (e) {
    L.warn('()', e);
    return {};
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromEntriesToObject;
